export default "__VITE_ASSET__R_X5vh8mzd3FWIQTzyrWbw__"